import {Component, Input, OnInit} from '@angular/core';
import { Store } from '@ngxs/store';
import {
  ConfigurationState,
  EquipmentOptions,
  PostingDataResponseModel,
  EditPostingState,
  UpdatePosting,
  EditPostingFormNames
} from 'remarketing-angular-library';
import { filter, has } from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { PostingFormDirective } from '../posting-form/posting-form.directive';
import {PostingAnalyticsHelperService} from '../../services/posting-analytics-helper.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';





@Component({
    selector: 'app-full-description-form',
    templateUrl: './full-description-form.component.html',
    styleUrls: ['./full-description-form.component.scss'],
    imports: [TranslocoDirective, FormsModule]
})
export class FullDescriptionFormComponent extends PostingFormDirective implements OnInit {
  postingData: PostingDataResponseModel;
  vehicleOptions = [];
  vehicleAdditionalOptions = [];
  newAdditionalVehicleOption: any;
  equipmentOptions: EquipmentOptions;
  showAddOptionForm = false;
  @Input() postingTypeString: string;

  constructor(
    private readonly store: Store,
    private readonly postingAnalyticsHelperService: PostingAnalyticsHelperService
  ) {
    super();
  }

  ngOnInit() {
    this.store
      .select(EditPostingState.updatedPosting)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(postingData => {
        this.postingData = postingData;
        this.equipmentOptions = this.postingData.inventoryItem.vehicleOptions.equipmentOptions;
        const recognizedArray: any[] = filter(this.equipmentOptions.vehicleAdditionalOptions, { unrecognized: false });
        this.vehicleAdditionalOptions = filter(this.equipmentOptions.vehicleAdditionalOptions, { unrecognized: true });
        if (this.equipmentOptions.vehicleOptions && this.equipmentOptions.vehicleOptions.length) {
          const dataArray = this.equipmentOptions.vehicleOptions.concat(recognizedArray);
          this.vehicleOptions = this.sortVehicleOptions(dataArray);
        }
      });
    this.setNewAdditionalVehicleOptVal();
    this.sendPageloadAnalyticsEvent();
  }

  sendPageloadAnalyticsEvent() {
    this.postingAnalyticsHelperService.sendPageloadAnalyticsEvent(
      this.store.selectSnapshot(ConfigurationState.configuration).tenantName,
      this.postingTypeString,
      EditPostingFormNames.OPTIONS_ADDITIONAL
    );
  }

  /**
   *
   * @param options - incoming array of objects
   * @returns - it will return alphabetically sorted array
   */
  sortVehicleOptions(options): any[] {
    return options.sort((opt1, opt2) => {
      const nameA = this.getDescription(opt1);
      const nameB = this.getDescription(opt2);
      return nameA.localeCompare(nameB);
    });
  }

  //resets the newAdditionalVehicleOption property
  setNewAdditionalVehicleOptVal() {
    this.newAdditionalVehicleOption = {
      optionDescription: '',
      unrecognized: true,
      excluded: false,
      afterMarket: false
    };
  }

  /**
   *
   * @param event - respective element's event
   * @param vehiclAdvanceOption - current array item
   * @param key - property needs to update
   * updates the flag and editPosting state
   */
  updateAdditionalOption(event, vehiclAdvanceOption, key) {
    if (key === 'excluded') {
      vehiclAdvanceOption[key] = !event.target.checked;
    } else {
      vehiclAdvanceOption[key] = event.target.checked;
    }
    this.updatePostingData();
  }

  //updates posting state with latest values
  updatePostingData() {
    this.equipmentOptions.vehicleOptions = this.getItemsByPropName('installed');
    const unregArr = this.getItemsByPropName('unrecognized');
    this.equipmentOptions.vehicleAdditionalOptions = unregArr.concat(this.vehicleAdditionalOptions);
    this.store.dispatch(new UpdatePosting(this.postingData));
  }

  /**
   *
   * @param propName - property needs to refer
   * @returns - filtered arrays with respective to propName
   */
  getItemsByPropName(propName: string): any[] {
    return filter(this.vehicleOptions, obj => {
      return has(obj, propName);
    });
  }

  //toggle the add btn
  toggleAnotherOptionForm() {
    this.showAddOptionForm = !this.showAddOptionForm;
  }

  //pushing unrecognized options to addtional option
  addVehicleAdvancedOption() {
    if (this.newAdditionalVehicleOption && this.newAdditionalVehicleOption.optionDescription) {
      this.vehicleAdditionalOptions.push(this.newAdditionalVehicleOption);
      this.setNewAdditionalVehicleOptVal();
      this.updatePostingData();
    }
  }

  /**
   *
   * @param currentItem - respective array item
   * @returns - description of the options
   */
  getDescription(currentItem): string {
    return currentItem && (currentItem.platformCustomDescription || currentItem.optionDescription);
  }
}
